import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

const adminApi = axios.create({ baseURL: `${BASE}/api` });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("jk_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("jk_admin_token");
      if (!window.location.pathname.endsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export default adminApi;
